<template>
  <section class="mt-2">

    <OutOfOfficeFunctionbox :functionbox_uuid="functionbox_uuid"></OutOfOfficeFunctionbox>

    <InboxFilter
      :amount="2"
      v-if="checkValidVersion('4.3.0')"
      filterName="READ"
      v-model="filter_read"
    ></InboxFilter>

    <span v-if="functionbox_uuid != ''">
      <InboxFilter
        :amount="3"
        filterName="ASSIGNED"
        v-model="filter_assigned"
      ></InboxFilter>
      <InboxFilter
        :amount="2"
        filterName="STATUS"
        v-model="filter_status"
      ></InboxFilter>
    </span>
    <span v-if="functionbox_uuid == ''">
      <InboxFilter
        :amount="2"
        filterName="ARCHIVED" 
        v-model="filter_archived"
      ></InboxFilter>
    </span>
    <span v-if="issue_status.length != 0">
       <span v-if="functionbox_uuid != ''">
        <InboxFilterIssueStatus :amount=issue_status.length filterName="ISSUE_STATUS" v-model="filter_issue_status" :items="issue_status"></InboxFilterIssueStatus>
        </span>
        <span v-if="functionbox_uuid == ''">
      <InboxFilterIssueStatus :amount=issue_status.length filterName="MESSAGE_STATUS" v-model="filter_issue_status" :items="issue_status"></InboxFilterIssueStatus>
      </span>
    </span>

    
<div class="hidden-not-mobile pb-1" v-if="hasBulk">
  <b-form inline>
        <b-form-checkbox
          v-if="items.length != 0"
          v-model="update_all"
          @change="updateAll"
        ></b-form-checkbox>
     
        <span v-if="selected.length != 0">
          <b-button
                variant="danger"
                size="sm"
              v-if="hasBulkRemoveEnabled && hasRemoveEnabled"
                :title="$t('REMOVE')"
                class="float-right"
                @click="removeMessages"
                >{{ $t("REMOVE") }}</b-button>

          <FunctionboxAssignUsers v-if="hasAssignOtherEnabled && functionbox_uuid != ''" @assigned="AssignedMessages" :functionbox_uuid="functionbox_uuid" :selected="selected" size="sm" />        
          <FunctionboxAssignUsers v-if="hasAssignOtherEnabled && functionbox_uuid != '' && hasClaimed" @assigned="AssignedMessages" :functionbox_uuid="functionbox_uuid" :selected="selected" size="sm" action="clear" />
      </span>
      </b-form>
    </div>

    <span v-if="selected.length != 0 && hasBulk" class="hidden-mobile">
            <b-button
              variant="danger"
              size="sm"
              v-if="hasBulkRemoveEnabled && hasRemoveEnabled"
              :title="$t('REMOVE')"
              class="float-right"
              @click="removeMessages"
              >{{ $t("REMOVE") }}</b-button
            >
            <FunctionboxAssignUsers v-if="hasAssignOtherEnabled && functionbox_uuid != ''" @assigned="AssignedMessages" :functionbox_uuid="functionbox_uuid" :selected="selected" size="sm" />
            <FunctionboxAssignUsers v-if="hasAssignOtherEnabled && functionbox_uuid != '' && hasClaimed" @assigned="AssignedMessages" :functionbox_uuid="functionbox_uuid" :selected="selected" size="sm" action="clear" />
    </span>

    <b-table
      v-if="fields"
      :key="'inbox_' + redrawIndex"
      small
      bordered
      :items="items"
      hover
      class="mt-2 ml-0 pl-0"
      :fields="fields"
      :tbody-tr-class="rowClass"
      :busy="loading"
      @row-clicked="clickedRow"
    >
      <template #head(removed)>
        <b-form-checkbox
          v-if="items.length != 0"
          v-model="update_all"
          @change="updateAll"
        ></b-form-checkbox>
      </template>

       <template v-slot:cell(removed)="data">
        <b-form-checkbox
          v-model="selected"
          name="check-button"
          :value="data.item.message_uuid"
        ></b-form-checkbox>
      </template>

      <template v-slot:cell(created_date)="data"><div @click="onCellClick(data)">{{
        FormatDateTime(data.item.created_date)
      }}</div></template>

      <template v-slot:cell(size)="data">
        <div @click="onCellClick(data)">{{ bytesToSize(data.item.size) }}</div>
      </template>

      <template v-slot:cell(from_email)="data">
        <div @click="onCellClick(data)"><span v-if="data.item.message_type == 'notification'">-</span>
        <span v-if="data.item.message_type != 'notification'"
          ><span v-if="data.item.from_name != ''"
            >{{ data.item.from_name
            }}<span v-if="data.item.from_email != ''"
              >, {{ data.item.from_email }}</span
            ></span
          >
          <span v-if="data.item.from_name == ''">{{
            data.item.from_email
          }}</span></span
        ></div>
      </template>

      <template v-slot:cell(has_attachment)="data">
        <div @click="onCellClick(data)"><img
          class="icon mr-1"
          :src="messageIcon(data.item.message_type)"
          :alt="$t('MESSAGES.TYPE.' + data.item.message_type)"
        />  
        <MessageStatus :status="data.item.status"></MessageStatus>&nbsp;
        <i v-if="data.item.has_attachment" class="mr-1 fal fa-paperclip" />
        <i
          v-if="data.item.archived == 1 && functionbox_uuid && 1 == 0"
          class="fal fa-times-circle"
        /></div>
      </template>

      <template v-slot:cell(subject)="data">
        <div @click="onCellClick(data)">
        <div class="text-break">
          {{ data.item.subject }}
        </div>
        <div class="hidden-not-sm">
          {{ $t("FROM") }}
          <span v-if="data.item.message_type == 'notification'">-</span>
          <span v-if="data.item.message_type != 'notification'"
            ><span v-if="data.item.from_name != ''"
              >{{ data.item.from_name
              }}<span v-if="data.item.from_email != ''"
                >, {{ data.item.from_email }}</span
              ></span
            >
            <span v-if="data.item.from_name == ''">{{
              data.item.from_email
            }}</span></span
          >
          <div v-if="functionbox_uuid && data.item.claimed">
            {{ $t("CLAIMED_BY") }} {{ data.item.claimed }}
          </div>
        </div>
        </div>
      </template>

      <template v-slot:cell(claimed)="data">
        <div @click="onCellClick(data)">{{ data.item.claimed }}</div>
      </template>

      <template v-slot:cell(conversation_id)="data">        
        <div @click="onCellClick(data)"><span  v-if="data.item.claimed">
          <span v-if="data.item.claimed == user.information.email"><i class="fa-solid fa-circle green"></i></span>
          <span v-if="data.item.claimed != user.information.email"><i class="fa-solid fa-triangle blue"></i></span>
        </span></div>
      </template>

      <template v-slot:cell(to_email)="data">
        <div @click="onCellClick(data)"><span v-if="data.item.claimed">
          <span v-if="data.item.claimed == user.information.email"><i class="fa-solid fa-circle green"></i></span>
          <span v-if="data.item.claimed != user.information.email"><i class="fa-solid fa-triangle blue"></i></span>
        </span></div>
      </template>

      <template v-slot:cell(id)="data">
         <b-form-checkbox
          v-if="hasBulk"
          v-model="selected"
          name="check-button"
          :value="data.item.message_uuid"
        ></b-form-checkbox>
        <span @click="onCellClick(data)">
          <img
            class="icon mr-1"
            :src="messageIcon(data.item.message_type)"
            :alt="$t('MESSAGES.TYPE.' + data.item.message_type)"
          />
          <MessageStatus :status="data.item.status"></MessageStatus>&nbsp;
          <span v-if="data.item.has_attachment"
            ><i class="fal fa-paperclip"
          /></span>
          <div class="text-break">{{ data.item.subject }}</div>
          <div class="time-information f12">
            {{ FormatDateTime(data.item.created_date) }}
          </div>
          <p>{{ $t("FROM") }} {{ data.item.from_email }}</p>
        </span>
      </template>



      <template #table-busy>
        <div class="text-center my-2">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </template>
    </b-table>


      <div v-if="!hasBulk">
        <b-pagination
          class="mt-2"
          v-model="currentPage"
          :total-rows="totalItems"
          :per-page="limit"
          align="center"
          @input="getInbox"
          pills
        >
          <template v-slot:first-text>{{ $t("PAGINATION.FIRST") }}</template>
          <template v-slot:prev-text>{{ $t("PAGINATION.PREV") }}</template>
          <template v-slot:next-text>{{ $t("PAGINATION.NEXT") }}</template>
          <template v-slot:last-text>{{ $t("PAGINATION.LAST") }}</template>
        </b-pagination>
      </div>
      <div v-if="hasBulk">
            


     
     <b-row>
      <b-col cols="12" md="6">
        <div v-if="selected.length != 0">
          <b-form inline>
            <b-button
              :disabled="selected.length == 0"
              variant="danger"
              :title="$t('REMOVE')"
              @click="removeMessages"
              >{{ $t("REMOVE") }}</b-button
            >
            <FunctionboxAssignUsers v-if="hasAssignOtherEnabled" @assigned="AssignedMessages" :functionbox_uuid="functionbox_uuid" :selected="selected" />
            <FunctionboxAssignUsers v-if="hasAssignOtherEnabled && hasClaimed" @assigned="AssignedMessages" :functionbox_uuid="functionbox_uuid" :selected="selected" action="clear" />
          </b-form>
        </div>
      </b-col>
      <b-col cols="12" md="6">

        <b-pagination
          class="mt-2"
          v-model="currentPage"
          :total-rows="totalItems"
          :per-page="limit"
          align="center"
          @input="getInbox"
          pills
        >
        </b-pagination>
      </b-col>
    </b-row>

      </div>
  </section>
</template>
<script>
import FunctionboxAssignUsers from "@/components_4_4/Input/AssignUsers";
import MessageStatus from "@/components/View/MessageStatus";
import InboxFilter from "@/components/Input/Filter/InboxFilter";
import InboxFilterIssueStatus from "@/components_4_4/Input/Filter/InboxFilterIssueStatus";
import OutOfOfficeFunctionbox from "@/components_4_4/OutOfOfficeFunctionbox";
export default {
  components: { MessageStatus, InboxFilter, InboxFilterIssueStatus, OutOfOfficeFunctionbox,FunctionboxAssignUsers },
  props: [
    "searchText",
    "limit",
    "functionbox_uuid",
    "user_uuid",
    "update_message_uuid",
  ],
  data() {
    return {
      loading: false,
      currentPage: 1,
      redrawIndex: 0,
      items: [],
      selectedIndex: 0,
      totalItems: 0,
      state: 1,
      archived: 0,
      filter_read: ["0", "1"],
      filter_archived: ["0"],
      filter_assigned: ["0", "2"],
      filter_status: ["0"],
      filter_issue_status: [],
      issue_status: [],
      selected: [],
      update_all: false,
      hasBulkRemoveEnabled: false,
      assign_user_uuid: "",
      hasAssignOtherEnabled: false
    };
  },
  methods: {    
    AssignedMessages(){
      this.selected = [];
      this.getInbox();
    },    
    async GetEnabledAssignOthers(){
      if(this.functionbox_uuid)
      {
        try {
          let result = await this.$http.get(this.user.hostname + "/sefos-message/assign-enabled?functionbox_uuid=" + this.functionbox_uuid); 
          if(result.data)
          {
            this.hasAssignOtherEnabled = result.data;
          }
        } catch {
          console.log("Could not fetch has-bulk-remove");
        }
      }
    },
    async GetEnabledBulk(){
      try {
        let result = await this.$http.get(this.user.hostname + "/sefos-message/has-bulk-remove");
        if(result.data)
        {
          this.hasBulkRemoveEnabled = result.data;
        }
      } catch {
        console.log("Could not fetch has-bulk-remove");
      }
    },
    removeMessages(){
      let self = this;
      this.$bvModal
        .msgBoxConfirm(this.$t("ARE_YOU_SURE"), {
          size: "sm",
          buttonSize: "sm",
          okVariant: "primary",
          okTitle: this.$t("YES"),
          cancelTitle: this.$t("NO"),
          bodyClass: "messagebox",
          dialogClass: this.teams.theme,
          footerClass: "p-2  text-center messagebox",
          hideHeaderClose: false,
          centered: true,
        })
        .then(function (value) {
          if (value) {
            self.$http
              .post(self.user.hostname + "/message/remove", {
                functionbox_uuid: self.functionbox_uuid,
                messageUuids: self.selected,
                message_uuid: "",
                user_uuid: self.user_uuid
              })
              .then(function () {
                self.selected = [];
                self.update_all = false;
                self.$noty.info(self.$t("REMOVED"));
                self.getInbox();
              })
              .catch(() => {
              });
          }
        })
        .catch(function () {});
    }, 
    updateAll: function () {
      if (this.update_all) {
        this.selected = this.items.map((a) => a.message_uuid);
      } else {
        this.selected = [];
      }
    },
    messageIcon(message_type) {
      return "/img/message_type/" + message_type + ".png";
    },
    clearFilterAssigned() {
      this.filter_assigned = [];
      this.getInbox();
    },
    clearFilterStatus() {
      this.filter_status = [];
      this.getInbox();
    },
    clearFilterArchived() {
      this.filter_archived = [];
      this.getInbox();
    },
    clearFilterAll() {
      this.filter_read = ["0", "1"];
      if(this.functionbox_uuid != "")
      {
        this.filter_archived = [];
        this.filter_assigned = [];
        this.filter_issue_status = [];
      }else{
        this.filter_status = [];
        this.filter_issue_status = [];
      }
      this.getInbox();
    },
    rowClass(item, type) {
      if (item && type === "row") {
        let returnClass = "";
        /*if (item.claimed != null) {
          if (this.functionbox_uuid != "") {
            if(this.user.email == item.claimed)
            {
              returnClass = "claimed";
            }else{
              returnClass = "claimed-others";
            }
          }
        }*/
        if (item.archived != 0) {
          if (this.functionbox_uuid != "") {
            returnClass = "archived";
          }
        }
        if (item.fetched === 0) {
          returnClass += " not-viewed";
        }
        return returnClass;
      }
      return "";
    },    
    onCellClick(data) {
      this.selectedIndex = data.index;     
      if(data.item.message_type == 'notification')
      {
        this.$emit("viewingNotification",data.item);
      }else{
        this.$emit("viewingMessage", data.item.message_uuid);
      }
    },
    clickedRow(data, index, event) {
      const td = event.target.closest('td');
      const cellIndex = td ? td.cellIndex : -1;
      if (this.hasBulk && (cellIndex === 0 || cellIndex === 1) ) {
        return;
      }
      if (!this.hasBulk && cellIndex === 0 ) {
        return;
      }
      this.selectedIndex = index;
      if (data.message_type == "notification") {
        this.$emit("viewingNotification", data);
      } else {
        this.$emit("viewingMessage", data.message_uuid);
      }
    },
    bytesToSize(bytes, decimals = 2) {
      if (bytes === 0) return "0";
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    },
    GetIssueStatus(){
      let self = this;
      if(this.functionbox_uuid){
        this.$http.get(this.user.hostname + "/message/issue-status/" + this.functionbox_uuid + "?ShowOld=true")
          .then(function(result) {
            self.issue_status = result.data;
            self.getInbox();
          })
          .catch(function() {
            self.getInbox();
          });
      }else{
        if(this.user_uuid){
          this.$http.get(this.user.hostname + "/message/issue-status/?user_uuid=" + this.user_uuid + "&ShowOld=true")
            .then(function(result) {
              self.issue_status = result.data;
              self.getInbox();
            })
            .catch(function() {
              self.getInbox();
            });
        }else{
          this.$http.get(this.user.hostname + "/message/issue-status?ShowOld=true")
            .then(function(result) {
              self.issue_status = result.data;
              self.getInbox();
            })
            .catch(function() {
              self.getInbox();
            });
          }
      }
    },
    getInbox: function () {
      let self = this;
      if(!this.loading)
      {
        this.loading = true;
        this.$http
          .post(this.user.hostname + "/inbox/list", {
            functionbox_uuid: this.functionbox_uuid,
            user_uuid: this.user_uuid,
            page: this.currentPage,
            limit: parseInt(this.limit),
            state: this.state,
            search_text: this.searchText,
            filter_status: this.filter_status,
            filter_assigned: this.filter_assigned,
            filter_archived: this.filter_archived,
            filter_read: this.filter_read,
            filter_issue_status: this.filter_issue_status
          })
          .then((response) => {
            self.redrawIndex = self.redrawIndex + 1;
            self.loading = false;
            self.$emit("changeUpdateMessageUuid", "");
            self.items = response.data.items;
            self.totalItems = response.data.count;
          })
          .catch((error) => {
            self.loading = false;
            if(error.toString() == "Error: fail_4_4") return;
            self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH_DATA"));
          });
      }
    },
    UpdateItem: function (message_uuid) {
      if (message_uuid != "") {
        let self = this;
        this.$http
          .post(this.user.hostname + "/inbox/message-update", {
            functionbox_uuid: this.functionbox_uuid,
            user_uuid: this.user_uuid,
            message_uuid: message_uuid,
          })
          .then((response) => {
            if (response.data.removed == 1 || response.data.removed == 1) {
              self.items.splice(self.selectedIndex, 1);
            } else {
              self.items[self.selectedIndex] = response.data;
            }
            self.redrawIndex = self.redrawIndex + 1;
          })
          .catch(() => {});
      }
    },
    HandleFilter(items, name) {
      if (this.functionbox_uuid != "") {
        localStorage.setItem(
          name + "_" + this.functionbox_uuid.replace(":", "_"),
          JSON.stringify(items)
        );
      } else {
        if (this.user_uuid != "") {
          localStorage.setItem(
            name + "_" + this.user_uuid.replace(":", "_"),
            JSON.stringify(items)
          );
        } else {
          localStorage.setItem(name, JSON.stringify(items));
        }
      }
    },
    GetFilter(name, ifNull) {
      if (this.functionbox_uuid != "") {
        if (
          localStorage.getItem(
            name + "_" + this.functionbox_uuid.replace(":", "_")
          ) !== null
        ) {
          return JSON.parse(
            localStorage.getItem(
              name + "_" + this.functionbox_uuid.replace(":", "_")
            )
          );
        } else {
          return ifNull;
        }
      } else {
        if (this.user_uuid != "") {
          if (
            localStorage.getItem(
              name + "_" + this.user_uuid.replace(":", "_")
            ) !== null
          ) {
            return JSON.parse(
              localStorage.getItem(
                name + "_" + this.user_uuid.replace(":", "_")
              )
            );
          } else {
            return ifNull;
          }
        } else {
          if (localStorage.getItem(name) !== null) {
            return JSON.parse(localStorage.getItem(name));
          } else {
            return ifNull;
          }
        }
      }
    },
  },
  computed: {    
    hasBulk(){
      return this.hasAssignOtherEnabled || (this.hasRemoveEnabled && this.hasBulkRemoveEnabled);
    },
    fields(){
      if(this.functionbox_uuid)
      {
        if(this.issue_status.length > 0){
          if(this.hasBulk)
          {
            return [        
              {
                key: "removed",
                label: "",
                class: "text-break w-20 text-center hidden-mobile",
                sortable: false,
              },
              {
                key: "conversation_id",
                label: "",
                class: "text-break w-20 text-center hidden-mobile",
                sortable: false,
              },
              {
                key: "to_email",
                label: "",
                class: "text-break w-20 text-center hidden-not-mobile",
                thClass: "hidden",
                sortable: false,
              },
              {
                key: "id",
                class: "hidden-not-mobile",
                thClass: "hidden",
              },
              {
                key: "has_attachment",
                label: "",
                class: "text-break w-80 clickable hidden-mobile",
                thClass: "w-80",
                sortable: false,
              },  
              {
                key: "subject",
                label: this.$t("SUBJECT"),
                class: "text-break clickable hidden-mobile",
                thClass: "hidden-mobile",
                sortable: true,
              },
              {
                key: "from_email",
                label: this.$t("FROM"),
                class: "text-break clickable hidden-sm",
                thClass: "hidden-mobile",
                sortable: true,
              },
              {
                key: "claimed",
                label: this.$t("CLAIMED_BY"),
                class: "text-break clickable hidden-sm",
                thClass: "hidden-mobile",
                sortable: true,
              },
              {
                key: "issueStatus",
                label: this.$t("ISSUE_STATUS"),
                class: "text-break clickable hidden-sm",
                thClass: "hidden-mobile",
                sortable: true,
              },
              {
                key: "created_date",
                label: this.$t("CREATED"),
                class: "text-break w-date clickable hidden-mobile",
                thClass: "hidden-mobile",
                sortable: true,
              },
            ];
          }else{
            return [        
            {
              key: "conversation_id",
              label: "",
              class: "text-break w-20 text-center hidden-mobile",
              sortable: false,
            },
            {
              key: "to_email",
              label: "",
              class: "text-break w-20 text-center hidden-not-mobile",
              thClass: "hidden",
              sortable: false,
            },
            {
              key: "id",
              class: "hidden-not-mobile",
              thClass: "hidden",
            },
            {
              key: "has_attachment",
              label: "",
              class: "text-break w-80 clickable hidden-mobile",
              thClass: "w-80",
              sortable: false,
            },  
            {
              key: "subject",
              label: this.$t("SUBJECT"),
              class: "text-break clickable hidden-mobile",
              thClass: "hidden-mobile",
              sortable: true,
            },
            {
              key: "from_email",
              label: this.$t("FROM"),
              class: "text-break clickable hidden-sm",
              thClass: "hidden-mobile",
              sortable: true,
            },
            {
              key: "claimed",
              label: this.$t("CLAIMED_BY"),
              class: "text-break clickable hidden-sm",
              thClass: "hidden-mobile",
              sortable: true,
            },
            {
              key: "issueStatus",
              label: this.$t("ISSUE_STATUS"),
              class: "text-break clickable hidden-sm",
              thClass: "hidden-mobile",
              sortable: true,
            },
            {
              key: "created_date",
              label: this.$t("CREATED"),
              class: "text-break w-date clickable hidden-mobile",
              thClass: "hidden-mobile",
              sortable: true,
            },
          ];
          }
        }else{          
          if(this.hasBulk)
          {
            return [            
              {
                key: "removed",
                label: "",
                class: "text-break w-20 text-center hidden-mobile",
                sortable: false,
              },      
              {
                key: "conversation_id",
                label: "",
                class: "text-break w-20 text-center hidden-mobile",
                sortable: false,
              },
              {
                key: "to_email",
                label: "",
                class: "text-break w-20 text-center hidden-not-mobile",
                thClass: "hidden",
                sortable: false,
              },
              {
                key: "id",
                class: "hidden-not-mobile",
                thClass: "hidden",
              },
              {
                key: "has_attachment",
                label: "",
                class: "text-break w-80 clickable hidden-mobile",
                thClass: "w-80",
                sortable: false,
              },  
              {
                key: "subject",
                label: this.$t("SUBJECT"),
                class: "text-break clickable hidden-mobile",
                thClass: "hidden-mobile",
                sortable: true,
              },
              {
                key: "from_email",
                label: this.$t("FROM"),
                class: "text-break clickable hidden-sm",
                thClass: "hidden-mobile",
                sortable: true,
              },
              {
                key: "claimed",
                label: this.$t("CLAIMED_BY"),
                class: "text-break clickable hidden-sm",
                thClass: "hidden-mobile",
                sortable: true,
              },
              {
                key: "created_date",
                label: this.$t("CREATED"),
                class: "text-break w-date clickable hidden-mobile",
                thClass: "hidden-mobile",
                sortable: true,
              },
            ];
          }else{
            return [  
              {
                key: "conversation_id",
                label: "",
                class: "text-break w-20 text-center hidden-mobile",
                sortable: false,
              },
              {
                key: "to_email",
                label: "",
                class: "text-break w-20 text-center hidden-not-mobile",
                thClass: "hidden",
                sortable: false,
              },
              {
                key: "id",
                class: "hidden-not-mobile",
                thClass: "hidden",
              },
              {
                key: "has_attachment",
                label: "",
                class: "text-break w-80 clickable hidden-mobile",
                thClass: "w-80",
                sortable: false,
              },  
              {
                key: "subject",
                label: this.$t("SUBJECT"),
                class: "text-break clickable hidden-mobile",
                thClass: "hidden-mobile",
                sortable: true,
              },
              {
                key: "from_email",
                label: this.$t("FROM"),
                class: "text-break clickable hidden-sm",
                thClass: "hidden-mobile",
                sortable: true,
              },
              {
                key: "claimed",
                label: this.$t("CLAIMED_BY"),
                class: "text-break clickable hidden-sm",
                thClass: "hidden-mobile",
                sortable: true,
              },
              {
                key: "created_date",
                label: this.$t("CREATED"),
                class: "text-break w-date clickable hidden-mobile",
                thClass: "hidden-mobile",
                sortable: true,
              },
            ];
          }
        }
      }else{
        if(this.issue_status.length > 0){
          if(this.hasBulk)
          {
            return [
              {
                key: "removed",
                label: "",
                class: "text-break w-20 text-center hidden-mobile",
                sortable: false,
              },
              {
                key: "id",
                class: "hidden-not-mobile",
                thClass: "hidden",
              },
              {
                key: "has_attachment",
                label: "",
                class: "text-break w-80 clickable hidden-mobile",
                sortable: false,
              },
              {
                key: "subject",
                label: this.$t("SUBJECT"),
                class: "text-break clickable hidden-mobile",
                thClass: "hidden-mobile",
                sortable: false,
              },
              {
                key: "from_email",
                label: this.$t("FROM"),
                class: "text-break clickable hidden-sm",
                thClass: "hidden-mobile",
                sortable: false,
              },
              {
                key: "issueStatus", 
                label: this.$t("FILTER.MESSAGE_STATUS.TITLE"),
                class: "text-break clickable hidden-sm",
                thClass: "hidden-mobile",
                sortable: true,
              },
              {
                key: "created_date",
                label: this.$t("CREATED"),
                class: "text-break w-date clickable hidden-mobile",
                thClass: "hidden-mobile",
                sortable: false,
              },
            ];
          }else{
            return [
              {
                key: "id",
                class: "hidden-not-mobile",
                thClass: "hidden",
              },
              {
                key: "has_attachment",
                label: "",
                class: "text-break w-80 clickable hidden-mobile",
                sortable: false,
              },
              {
                key: "subject",
                label: this.$t("SUBJECT"),
                class: "text-break clickable hidden-mobile",
                thClass: "hidden-mobile",
                sortable: false,
              },
              {
                key: "from_email",
                label: this.$t("FROM"),
                class: "text-break clickable hidden-sm",
                thClass: "hidden-mobile",
                sortable: false,
              },
              {
                key: "issueStatus",
                label: this.$t("FILTER.MESSAGE_STATUS.TITLE"),
                class: "text-break clickable hidden-sm",
                thClass: "hidden-mobile",
                sortable: true,
              },
              {
                key: "created_date",
                label: this.$t("CREATED"),
                class: "text-break w-date clickable hidden-mobile",
                thClass: "hidden-mobile",
                sortable: false,
              },
            ];
          }
        }else{
          if(this.hasBulk)
          {
            return [
              {
                key: "removed",
                label: "",
                class: "text-break w-20 text-center hidden-mobile",
                sortable: false,
              },
              {
                key: "id",
                class: "hidden-not-mobile",
                thClass: "hidden",
              },
              {
                key: "has_attachment",
                label: "",
                class: "text-break w-80 clickable hidden-mobile",
                sortable: false,
              },
              {
                key: "subject",
                label: this.$t("SUBJECT"),
                class: "text-break clickable hidden-mobile",
                thClass: "hidden-mobile",
                sortable: false,
              },
              {
                key: "from_email",
                label: this.$t("FROM"),
                class: "text-break clickable hidden-sm",
                thClass: "hidden-mobile",
                sortable: false,
              },
              {
                key: "created_date",
                label: this.$t("CREATED"),
                class: "text-break w-date clickable hidden-mobile",
                thClass: "hidden-mobile",
                sortable: false,
              },
            ];
          }else{
            return [
              {
                key: "id",
                class: "hidden-not-mobile",
                thClass: "hidden",
              },
              {
                key: "has_attachment",
                label: "",
                class: "text-break w-80 clickable hidden-mobile",
                sortable: false,
              },
              {
                key: "subject",
                label: this.$t("SUBJECT"),
                class: "text-break clickable hidden-mobile",
                thClass: "hidden-mobile",
                sortable: false,
              },
              {
                key: "from_email",
                label: this.$t("FROM"),
                class: "text-break clickable hidden-sm",
                thClass: "hidden-mobile",
                sortable: false,
              },
              {
                key: "created_date",
                label: this.$t("CREATED"),
                class: "text-break w-date clickable hidden-mobile",
                thClass: "hidden-mobile",
                sortable: false,
              },
            ];
          }
        }

      }
    },
    showFilterClearAll() {      
      if (this.functionbox_uuid == "") { 
        if (this.filter_archived.length > 0) {
          return true;
        }
      }
      if (this.functionbox_uuid != "") { 
        if (this.filter_assigned.length > 0) {
          return true;
        }
        if (this.filter_status.length > 0) {
          return true;
        }
      }
      if (this.filter_read.length > 0) {
        return true;
      }
      if (this.filter_issue_status.length > 0) {
        return true;
      }
      return false;
    },
    hasClaimed(){
      let self = this;
      return this.items.some(function (item) { 
        return item.claimed != null && self.selected.includes(item.message_uuid);
      });
    },
    hasRemoveEnabled(){
      if(this.user.information.organisation.users_can_remove == undefined)
      {
        return false;
      }
      return this.user.information.organisation.users_can_remove;
    }
  },
  watch: {
    filter_assigned: function (new_array) {
      this.HandleFilter(new_array, "message_inbox_assigned");
      this.getInbox();
    },
    filter_archived: function (new_array) {
      this.HandleFilter(new_array, "message_inbox_archived");
      this.getInbox();
    },
    filter_status: function (new_array) {
      this.HandleFilter(new_array, "message_inbox_status");
      this.getInbox();
    },
    filter_read: function (new_array) {
      this.HandleFilter(new_array, "message_inbox_read");
      this.getInbox();
    },    
    filter_issue_status: function (new_array) {
      this.HandleFilter(new_array, "message_inbox_filter_issue_status");
      this.getInbox();
    },
    update_message_uuid: function (new_message_uuid) {
      this.UpdateItem(new_message_uuid);
    },
    searchText: function () {
      if (this.searchText.length == 0) {
        this.getInbox();
      }
      if (this.searchText.length >= 2) {
        this.getInbox();
      }
    },
    limit: function () {
      this.getInbox();
    },
  },
  mounted: function () {
    this.filter_assigned = this.GetFilter(
      "message_inbox_assigned",
      this.filter_assigned
    );
    this.filter_status = this.GetFilter(
      "message_inbox_status",
      this.filter_status
    );
    this.filter_archived = this.GetFilter(
      "message_inbox_archived",
      this.filter_archived
    );
    this.filter_read = this.GetFilter("message_inbox_read", this.filter_read);
    this.filter_issue_status = this.GetFilter("message_inbox_filter_issue_status", this.filter_issue_status);
    this.GetIssueStatus();
    this.GetEnabledBulk();
    this.GetEnabledAssignOthers();
  },
};
</script>
<style></style>
